$(() => {
  $('#copy-url').on('click' ,function (e) {
    e.preventDefault()
    const url = window.location.href;
    if (navigator.clipboard) {
      navigator.clipboard.writeText(url)
        .then(() => {
          console.log('URL copied successfully');
          alert('URLをコピーしました')
        })
        .catch(err => {
          console.error('Failed to copy URL: ', err);
        });
    } else {
      // Clipboard APIがサポートされていない場合の代替手段
      const tempInput = document.createElement('input');
      tempInput.value = url;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand('copy');
      document.body.removeChild(tempInput);
      alert('URLをコピーしました')
    }
  });
})